<template>
    <section class="channel vidget_wrap">
        <div class="channel__wrapper">
            <div class="channel__map">
                <mapbox class="channel__mapbox" :accessToken="accessToken" :map-options="options"></mapbox>
            </div>
            <div class="channel__content page__section">
                <h2 class="page__h1 channel__h2 detectMobVisibility" v-html="$t('scale.title')"></h2>
                <div class="numbers">
                    <div
                        v-for="partner in $t('scale.partners')"
                        :key="partner.title"
                        class="numbers__item detectMobVisibility"
                    >
                        <div class="numbers_wraps" data-wraps="1">
                            <div class="numbers__name">{{ partner.title }}</div>
                            <div class="numbers__count">{{ partner.count }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="page__section">
            <h2 class="page__h2 detectMobVisibility">
                <span class="textHide">
                    <span>{{ $t('scale.own_stores') }}</span>
                </span>
            </h2>
            <div class="channel__text-wrap">
                <div
                    class="channel__text textFade detectMobVisibility"
                >{{ $t('scale.descr_stores') }}</div>
                <div class="channel__text-container">
                    <div class="channel__text-link-wrap">
                        <a href="https://wo.ua/" class="channel__text channel__text-link" target="_blank" rel="noopener noreferrer">wo.ua</a>
                        <a href="https://yunmai.ua/" class="channel__text channel__text-link" target="_blank" rel="noopener noreferrer">yunmai.ua</a>
                    </div>
                    <div class="channel__text-link-wrap">
                        <a href="https://deebot.ua/" class="channel__text channel__text-link" target="_blank" rel="noopener noreferrer">deebot.ua</a>
                        <a href="https://cecotec.tech/" class="channel__text channel__text-link" target="_blank" rel="noopener noreferrer">cecotec.tech</a>
                    </div>
                    <div class="channel__text-link-wrap">
                        <a href="https://deerma.com.ua/" class="channel__text channel__text-link" target="_blank" rel="noopener noreferrer">deerma.com.ua</a>
                        <a href="https://jimmy.com.ua/" class="channel__text channel__text-link" target="_blank" rel="noopener noreferrer">jimmy.com.ua</a>
                    </div>
                </div>
            </div>
            <div class="channel__image-wrapper textFade detectMobVisibility">
                <div
                    :style="{ backgroundImage: 'url(' + require('@/assets/images/channel_image.jpg') + ')' }"
                    class="channel__image"
                ></div>
            </div>
            <div class="channel__bottom detectMobVisibility">
                <h2 class="page__h2">
                    <span class="textHide">
                        <span>{{ $t('scale.motivation') }}</span>
                    </span>
                </h2>
                <div class="channel__text textFade">{{ $t('scale.descr_motivation') }}</div>
            </div>
            <div
                class="channel__image-wrapper channel__image-second-wrapper textFade detectMobVisibility"
            >
                <div
                    :style="{ backgroundImage: 'url(' + require('@/assets/images/channel_second_image.png') + ')' }"
                    class="channel__image"
                ></div>
            </div>
        </div>
    </section>
</template>

<script>
import Mapbox from "mapbox-gl-vue";

export default {
    data() {
        return {
            accessToken:
                "pk.eyJ1IjoidGF5YXEiLCJhIjoiY2pqNWttc3pnMDF5YTNrcGZ2MjgxdnJmcSJ9.FYBtnxzTWi0BhKf4d0xyog",
            options: {
                style: "mapbox://styles/tayaq/cjjsugp0g19md2so4ctthrz6r",
                center: [32, 48.5],
                zoom: 6,
                attributionControl: false
            }
        };
    },
    components: {
        Mapbox
    },
    mounted() {
        var minWidth = $(window).width(),
            obj = $(".channel__image");

        $(window).on("mousewheel DOMMouseScroll", function(e) {
            let section = $(".fp-section.active");

            if (section.hasClass("scrollBox") && minWidth >= 1024) {
                let box = $(".fp-scroller", section)[0],
                    style = window.getComputedStyle(box),
                    matrix = new WebKitCSSMatrix(style.webkitTransform),
                    allHeight = $(".channel.vidget_wrap", section).height(),
                    screenCenter = allHeight / 2;

                let prop =
                    Math.round((matrix.m42 / screenCenter) * 100).toFixed(2) *
                    -1;
                var imgPosY = 0;

                if (prop > 65) {
                    if (!obj.hasClass("rolledDown")) {
                        obj.removeClass("rolledUp").addClass("rolledDown");
                    }
                    imgPosY = Math.round((prop - 65) * 2).toFixed(2);
                } else {
                    if (obj.hasClass("rolledDown")) {
                        obj.removeClass("rolledDown").addClass("rolledUp");
                    }
                }

                obj.css({ "background-position": "0 " + imgPosY + "%" });
            }
        });
    }
};
</script>

<style lang="stylus" scoped>
.channel {
    background: #fff;
    color: #000;
}

.page__section {
    position: relative;

    @media (min-width: 1024px) and (max-width: 1219px) {
        padding-left: 183px;
    }
}

.channel__h2 {
    margin-top: 75px;
    max-width: 300px;

    @media (min-width: 700px) {
        max-width: 550px;
    }

    @media (min-width: 1600px) {
        max-width: 750px;
    }
}

.channel__image-wrapper {
    width: calc(100% + 40px);
    height: 170px;
    position: relative;
    left: -20px;
    margin: 32px 0 48px;

    @media (min-width: 500px) {
        width: 500px;
        left: calc(50% - 250px);
    }

    @media (min-width: 700px) {
        width: 700px;
        height: 235px;
        left: calc(50% - 350px);
    }

    @media (min-width: 1024px) {
        margin: 64px 0;
        width: 830px;
        height: 320px;
        left: calc(50% - 480px);
    }

    @media (min-width: 1100px) {
        width: 960px;
    }
}

.channel__image {
    width: 0;
    height: 6px;
    position: absolute;
    left: 0;
    top: 0;
    display: block;
    background-position: 0 0;
    background-size: 100% auto;
    background-repeat: no-repeat;
    -webkit-transition: 0.1s linear;
    -moz-transition: 0.1s linear;
    transition: 0.1s linear;

    @media (max-width: 1024px) {
        width: 100% !important;
        height: 100% !important;
        background-position: 0 0 !important;
    }

    @media (max-width: 516px) {
        width: calc(100% - 16px) !important;
        left: 8px;
    }
}

.channel__text-container {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
}

.channel__text-wrap {
    grid-template-columns: 1fr;
    grid-gap: 0;

    @media (min-width: 1024px) {
        justify-content: start;
        display: grid;
        grid-template-columns: 260px 1fr;
        grid-gap: 100px;
    }
}

.channel__text {
    margin-top: 16px;

    @media (min-width: 1024px) {
        max-width: 260px;

    }
}

.channel__text-link-wrap
    display flex
    flex-flow column

.channel__text-link {
    display: inline-block;
    font-weight: bold;
    text-decoration: underline;
}

.channel__bottom {
    @media (min-width: 1024px) and (max-width: 1289px) {
        position: relative;
        left: calc(50% - 480px);
    }
}

.channel__wrapper {
    position: relative;

    @media (min-width: 1024px) {
        height: fit-content;
    }
}

.channel__map {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
    z-index: 1 !important;

    &:before {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        content: '';
        display: none;
        z-index: 2;
        background: url('../assets/images/svg/map_triangles.svg') center no-repeat;

        @media (min-width: 1024px) {
            display: block;
        }
    }
}

.channel__mapbox {
    position: absolute;
    left: -12%;
    top: -12%;
    width: 124%;
    height: 124%;
}

.channel__content {
    position: relative;
    z-index: 4 !important;
}

.numbers {
    display: grid;
    grid-gap: 48px;
    line-height: 1;
    margin: 64px 0 80px;

    @media (min-width: 1024px) {
        grid-template-rows: repeat(2, 224px);
        grid-template-columns: repeat(3, 218px);
        grid-gap: 20px;
    }

    @media (min-width: 1366px) {
        margin-left: -83px;
        grid-template-rows: repeat(1, 224px);
        grid-template-columns: repeat(6, 170px);
        grid-gap: 12px;
    }

    @media (min-width: 1600px) {
        margin-left: 0;
        grid-template-columns: repeat(6, 190px);
        grid-gap: 20px;
    }

    @media (min-width: 1680px) {
        grid-template-columns: repeat(6, 205px);
    }

    @media (min-width: 1920px) {
        grid-template-columns: repeat(6, 224px);
    }
}

.numbers__item {
    display: flex;
    align-items: center;

    @media (min-width: 1024px) {
        position: relative;
    }
}

.numbers_wraps {
    height: 100%;
    display: flex;
    text-align: center;

    @media (min-width: 1024px) {
        position: absolute;
        top: 0;
        right: 0;
        overflow: hidden;
        background: #fff;
    }
}

.numbers__name {
    width: 100%;
    // flex-grow: 2;
    font-weight: 600;
    padding-bottom: 12px;
    background: url('../assets/images/svg/bl_dots.svg') center bottom repeat-x;

    @media (max-width: 1023px) {
        padding-top: 18px;
        text-align: left;
    }

    @media (min-width: 1024px) {
        position: absolute;
        // left: 20px;
        bottom: 20px;
        border: none;
        padding: 0;
        font-weight: normal;
        background: none;
    }
}

.numbers__count {
    font-size: 40px;
    padding-left: 15px;

    @media (max-width: 1023px) {
        width: 100px;
        text-align: left;
    }

    @media (min-width: 1024px) {
        width: 100%;
        text-align: center;
        padding: 0;
        font-size: 58px;
        position: absolute;
        top: 48px;
        left: 0;
    }
}

.channel__image {
    filter: grayscale(100%);

    &.rolledDown {
        -webkit-animation: rollDown 1s 1;
        -moz-animation: rollDown 1s 1;
        animation: rollDown 1s 1;
        -webkit-animation-fill-mode: forwards;
        -moz-animation-fill-mode: forwards;
        animation-fill-mode: forwards;
    }

    &.rolledUp {
        -webkit-animation: rollUp 1s 1;
        -moz-animation: rollUp 1s 1;
        animation: rollUp 1s 1;
        -webkit-animation-fill-mode: forwards;
        -moz-animation-fill-mode: forwards;
        animation-fill-mode: forwards;
    }
}

.channel__image-wrapper.channel__image-second-wrapper.textFade.detectMobVisibility {
    @media (min-width: 1024px) {
        width: 526px;
        height: 275px;
        margin: 0;
        padding: 30px 28px 12px;
        position: absolute;
        top: unset;
        right: 80px;
        bottom: 30px;
        left: unset;
        background: #fff;
        transform: scale(0.7);

        .channel__image {
            width: 100%;
            height: 100%;
            position: relative;
            background-position: 0 !important;
        }
    }

    @media (min-width: 1260px) {
        right: 160px;
    }

    @media (min-width: 1600px) {
        right: 300px;
    }

    @media (min-width: 1850px) {
        right: 500px;
    }
}

@keyframes rollDown {
    from, 40%, to {
        -webkit-animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
        animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    }

    0% {
        width: 0px;
        height: 4px;
    }

    40% {
        width: 100%;
        height: 4px;
    }

    to {
        width: 100%;
        height: 100%;
    }
}

@keyframes rollUp {
    from, 60%, to {
        -webkit-animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
        animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    }

    0% {
        width: 100%;
        height: 100%;
    }

    60% {
        width: 100%;
        height: 4px;
    }

    to {
        width: 0;
        height: 4px;
    }
}
</style>